<template lang="html">
  <div class="container">
    <div class="title pf-medium">老师微信号</div>
    <div class="main">
      <div class="left">
        <div class="desription">{{ extTeacherInfo.description }}</div>
        <div class="wx-row">
          <span class="wx-code-label">微信号：</span>
          <span class="wx-code" id="wx-code">{{
            extTeacherInfo.wxAccount
          }}</span>
          <span
            @click="copyWxAccount"
            ref="copyWxAccount"
            :data-clipboard-text="extTeacherInfo.wxAccount"
            data-clipboard-target="#wx-code"
            class="copy-text-btn"
          >
            复制
          </span>
        </div>
        <div class="tips">添加老师微信号，上课不迷路哦～</div>
      </div>
      <div class="right">
        <img class="qrcode" :src="extTeacherInfo.qrCode" />
        <button
          class="save2mobile"
          @click="save2mobile"
          v-if="shouldShowSaveBtn()"
        >
          保存到手机
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { saveImagesToAlbum, isAndroid, isIOS } from '@/utils'

export default {
  props: {
    extTeacherInfo: {
      type: Object,
      default: {}
    }
  },
  mounted() {
    this.copyBtn = new this.$$clipboard(this.$refs.copyWxAccount)
  },
  methods: {
    copyWxAccount() {
      let _this = this
      let clipboard = _this.copyBtn
      clipboard.on('success', function (e) {
        _this.$$toast('复制成功')
        return
      })
      clipboard.on('error', function (e) {
        window.prompt('复制失败，请手动复制', e.text)
      })
    },
    shouldShowSaveBtn() {
      return isAndroid() || isIOS()
    },
    save2mobile() {
      saveImagesToAlbum([this.extTeacherInfo.qrCode])
    }
  },
  computed: {},
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.container {
  margin: rem(20px) rem(24px) rem(20px);
  border-radius: rem(16px);
  background: #fff;
  padding: rem(32px) 0 rem(16px) 0;

  .title {
    font-size: rem(30px);
    padding: 0 0 0 rem(24px);
  }

  .main {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .left {
      width: 70%;
      margin-top: rem(40px);
      margin-left: rem(24px);
      .description {
        width: 102px;
        font-family: PingFangSC-Regular;
        font-size: rem(26px);
        color: #262626;
        font-weight: 400;
      }

      .wx-row {
        font-size: rem(26px);
        margin: rem(20px) 0;
        .wx-code-label {
          font-family: PingFangSC-Regular;
          color: #262626;
          font-weight: 400;
        }

        .wx-code {
          width: rem(183px);
          font-family: PingFangSC-Medium;
          color: #262626;
          font-weight: 500;
        }

        .copy-text-btn {
          font-family: PingFangSC-Regular;
          color: #ff5900;
          font-weight: 400;
          padding: rem(20px);
        }
      }

      .tips {
        font-family: PingFangSC-Regular;
        font-size: rem(26px);
        color: #999999;
        font-weight: 400;
      }
    }

    .right {
      width: 30%;
      margin-bottom: rem(38px);
      .qrcode {
        width: rem(152px);
        height: rem(152px);
      }

      .save2mobile {
        width: rem(152px);
        height: rem(48px);
        border: 1px solid rgba(255, 89, 0, 1);
        border-radius: rem(4px);
        font-family: PingFangSC-Regular;
        font-size: rem(24px);
        color: #ff5900;
        line-height: rem(36px);
        font-weight: 400;
        margin-top: rem(26px);
      }
    }
  }
}
</style>
